export const AccountabilityStatus = {
  NULL: {id: null, name: '--', filterName: ''},
  PENDING: {id: 1, name: 'Pendente', filterName: 'Pendente'},
  CONCLUDED: {id: 2, name: 'Concluído', filterName: 'Concluída'},
  REFUSED: {id: 3, name: 'Recusado', filterName: 'Recusada'},
  APPROVED: {id: 4, name: 'Aprovado', filterName: 'Aprovada'},
  AUTHORIZED: {id: 5, name: 'Autorizado', filterName: 'Autorizada'},
  PAID: {id: 6, name: 'Pago', filterName: 'Paga'},
};



// WEBPACK FOOTER //
// ./src/enums/AccountabilityStatus.js